import {
  DatasetDurationManager,
  ServiceUsingCountManager,
} from "@/services/license/base/license-manager-abstractions";
import { CustomVoiceDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/custom-voice-dataset-duration-limiter";
import { CustomVoiceUsingCountLimiter } from "@/services/license/license-limiters/service-using-count-limiters/custom-voice-using-count-limiter";
import { CustomVoiceQualityLimiter } from "@/services/license/license-limiters/service-quality-limiters/custom-voice-quality-limiter";

export class CustomVoiceLicenseManager
  implements DatasetDurationManager, ServiceUsingCountManager
{
  datasetDurationLimiter = new CustomVoiceDatasetDurationLimiter();
  serviceUsingCountLimiter = new CustomVoiceUsingCountLimiter();
  serviceQualityLimiter = new CustomVoiceQualityLimiter();
}

const customVoiceLicenseManager = new CustomVoiceLicenseManager();
export { customVoiceLicenseManager };
